import { Controller } from '@hotwired/stimulus'
import { toggle } from '../../lib/dom'

export default class extends Controller {
  static targets = [
    'paymentMethod',
    'card',
    'cardSelection',
    'cardCreation',
    'useCustomerData',
    'cardHolderData',
    'radio',
    'cardZero',
  ]

  connect() {
    this.paymentTypeChanged()
  }

  paymentTypeChanged(event) {
    if (event && event.target.checked) {
      this.radioTargets.forEach((radio) => {
        radio.checked = radio === event.target
      })
    }

    const showCardOptions = this.currentPaymentMethodValue === 'credit_card'

    this.cardZeroTarget.checked = showCardOptions
    this.cardZeroTarget.checked = showCardOptions
    toggle(this.cardCreationTarget, showCardOptions)
    this.useCustomerDataChanged()
  }

  useCustomerDataChanged(event) {
    toggle(this.cardHolderDataTarget, !this.useCustomerDataTarget.checked)

    if (event && !this.useCustomerDataTarget.checked) {
      this.cardHolderDataTarget.querySelector('input').focus()
    }
  }

  get currentPaymentMethod() {
    return this.paymentMethodTargets.find((target) => target.checked)
  }

  get currentPaymentMethodValue() {
    return this.currentPaymentMethod && this.currentPaymentMethod.value
  }
}
